import React, { useEffect, useState } from 'react';
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Col,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Label,
    Form,
    FormGroup,
    Input,
} from "reactstrap";
import DatePicker from "react-datepicker";

import { DatePickerHookForm, SearchableSelectHookForm, TextAreaHookForm, TextFieldHookForm } from '../../../../../../../layout/HookFormInputs';
import { Controller, useForm } from 'react-hook-form';
import FileUpload from '../../FileUpload';
import TooltipCustom from '../../../../../../../common/Tooltip';
import HeaderTitle from '../../../../../../../common/HeaderTitle';
import { API } from '../../../../../../../../config/constants';
import { apiErrors, notify, checkWhiteSpaces, number, alphaNumeric, isValidPAN } from '../../../../../../../../helper';
import { cloneDeep } from 'lodash';
import { getStateSelection, getYearOfBuisnessService } from '../../../../../../supplierListAll/Actions';
import axiosHelper from '../../../../../../../../axiosHelper';
import LoaderCustom from '../../../../../../../common/LoaderCustom';

let llpOpcCompanyEstablishment = [1, 4, 6];
let companyOpcEstablishment = [1, 6];
let llpPartnershipEstablishment = [3, 4];
let societyEstablishment = [7];

const fileConfig = {
    common: {
        allowedFileTypes: [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/msword", // Allow .doc files
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Allow .docx files
        ],
        maxSize: 5, // In MB
        validationMessage: "Unsupported file type. Please choose a file with one of the following formats: DOC, PDF, JPG, JPEG, PNG"
    },
    vendorCodeOfConductAttachment: {
        allowedFileTypes: [
            "application/pdf"
        ],
        maxSize: 5, // In MB
        validationMessage: "Unsupported file type. Please choose a file with one of the following formats: PDF."
    },
    productSourcingDocumentAttachment: {
        allowedFileTypes: [
            "application/pdf"
        ],
        maxSize: 20, // In MB
        validationMessage: "Unsupported file type. Please choose a file with one of the following formats: PDF."
    }
}
const tomorrowDate = new Date();
tomorrowDate.setDate(tomorrowDate.getDate());
let radioValidateMsg = "This field is required.";

const TaxationStatutory = (props) => {
    // let supplierDetail = props.supplierDetail;

    const [yearOfBusinessIncorporation, setYearOfBusinessIncorporation] = useState([])
    const [MSMEList, setMSMEList] = useState([])
    // 
    const [specializationList, setSpecializationList] = useState([])
    const [photographOfEstablishAttachment, setPhotographOfEstablishAttachment] = useState(null)
    const [pfRegistrationDocumentAttachment, setPFRegistrationDocumentAttachment] = useState(null)
    const [esiRegistrationDocumentAttachment, setESIRegistrationDocumentAttachment] = useState(null)
    const [yourOrganizationDocumentAttachment, setYourOrganizationDocumentAttachment] = useState(null)
    const [panNoDocumentAttachment, setPanNoDocumentAttachment] = useState(null)
    const [gstinDocumentAttachment, setGSTINDocumentAttachment] = useState(null)
    const [vendorCodeOfConductAttachment, setVendorCodeOfConductAttachment] = useState(null)
    const [productSourcingDocumentAttachment, setProductSourcingDocumentAttachment] = useState(null)
    const [exportLicenseDocumentAttachment, setExportLicenseDocumentAttachment] = useState(null)
    const [companyRegistrationDocumentAttachment, setCompanyRegistrationDocumentAttachment] = useState(null)
    const [iso9001DocumentAttachment, setISO9001DocumentAttachment] = useState(null)
    const [factoryLicenceDocumentAttachment, setFactoryLicenceDocumentAttachment] = useState(null)
    const [iso4001DocumentAttachment, setISO4001DocumentAttachment] = useState(null)
    const [iso26001DocumentAttachment, setISO26001DocumentAttachment] = useState(null)
    const [otherCertificationDocumentAttachment, setOtherCertificationDocumentAttachment] = useState(null)
    const [associationDocumentAttachment, setAssociationDocumentAttachment] = useState(null)
    const [partnershipDeedDocumentAttachment, setPartnershipDeedDocumentAttachment] = useState(null)
    const [trustDeedDocumentAttachment, setTrustDeedDocumentAttachment] = useState(null)
    const [stateOptionData, setOptionData] = useState([]);
    const [showTabLoader, setShowTabLoader] = useState(true)
    const [supplierDetail, setSupplierDetail] = useState(null)
    const [hasGSTINChanged, setHasGSTINChanged] = useState(false);
    const [isGstValid, setIsGstValid] = useState(false);
    const [kys1RequiredDocumentList, setKYS1RequiredDocumentList] = useState([])
    const [otherAgreementDocumentAttachment, setOtherAgreementDocumentAttachment] = useState(null)
    const [anyDocumentDocumentAttachment, setAnyDocumentDocumentAttachment] = useState(null)


    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("VendorRequirementRegistrationId");
        if (id) {
            GetKYS1DetailByVendorRRId(id)
            // getKYS1RequiredDocumentList(id)
        }
    }, []);

    // const getKYS1RequiredDocumentList = (id) => {
    //     axiosHelper.get(`${API.getKYS1RequiredDocumentList}?VendorRequirementRegistrationId=${id}`)
    //         .then(async (res) => {
    //             if (res?.data?.IsSuccessful) {
    //                 setKYS1RequiredDocumentList(res?.data?.Data);
    //             }
    //         })
    //         .catch((error) => {
    //             
    //         });
    // }

    const GetKYS1DetailByVendorRRId = (id) => {
        axiosHelper.get(`${API.GetKYS1DetailByVendorRRId}?VendorRequirementRegistrationId=${id}`)
            .then(async (res) => {
                setSupplierDetail(res?.data?.Data)
            })
            .catch((error) => {

            });
    }

    const formController = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
        defaultValues: {
            IsPFRegistration: "true",
            IsESIRegistration: "true",
            IsYourOrganization: "true",
            IsPanNO: "true",
            IsGSTIN: "true",
            ISO9001: "true",
            IsFactoryLicence: "true",
            ISO4001: "true",
            ISO26001: "true",
            ISOTSCertificationsOther: "true",
        }
    });


    const { register, handleSubmit, watch, clearErrors, setValue, trigger, getValues, reset, setError, formState: { errors, isSubmitted }, control, } = formController;

    useEffect(() => {
        getYearOfBusInessCorporation()
        getMSMEList()
        getSpecializationList()
    }, [])

    const getEmptyFileObjectForEditForm = (fileName) => {
        return fileName ? { fileName, base64String: "", fileType: "" } : null;
    }

    const hidePageLoader = () => setTimeout(() => {
        setShowTabLoader(false);
    }, 2000);

    const setTaxationFormEdit = (taxationStatutoryDetails) => {
        let PhotographOfEstablishAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.PhotographOfEstablishName);
        let PFRegistrationDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.PFRegistrationDocumentName);
        let ESIRegistrationDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.ESIRegistrationDocumentName);
        let YourOrganizationDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.YourOrganizationDocumentName);
        let PanNoDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.PanNoDocumentName);
        let GSTINDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.GSTINDocumentName);
        let VendorCodeOfConductAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.VendorCodeOfConductName);
        let ProductSourcingDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.ProductSourcingDocumentName);
        let ExportLicenseDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.ExportLicenseDocumentName);
        let CompanyRegistrationDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.CompanyRegistrationDocumentName);
        let ISO9001DocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.ISO9001DocumentName);
        let FactoryLicenceDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.FactoryLicenceDocumentName);
        let ISO4001DocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.ISO4001DocumentName);
        let ISO26001DocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.ISO26001DocumentName);
        let OtherCertificationDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.OtherCertificationDocumentName);
        let AssociationDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.AssociationDocumentName);
        let PartnershipDeedDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.PartnershipDeedDocumentName);
        let TrustDeedDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.TrustDeedDocumentName);
        let OtherAgreementDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.OtherAgreementDocumentName);
        let AnyDocumentDocumentAttachment = getEmptyFileObjectForEditForm(taxationStatutoryDetails?.AnyDocumentDocumentName);

        setPhotographOfEstablishAttachment(PhotographOfEstablishAttachment);
        setPFRegistrationDocumentAttachment(PFRegistrationDocumentAttachment);
        setESIRegistrationDocumentAttachment(ESIRegistrationDocumentAttachment);
        setYourOrganizationDocumentAttachment(YourOrganizationDocumentAttachment);
        setPanNoDocumentAttachment(PanNoDocumentAttachment);
        setGSTINDocumentAttachment(GSTINDocumentAttachment);
        setVendorCodeOfConductAttachment(VendorCodeOfConductAttachment);
        setProductSourcingDocumentAttachment(ProductSourcingDocumentAttachment);
        setExportLicenseDocumentAttachment(ExportLicenseDocumentAttachment);
        setCompanyRegistrationDocumentAttachment(CompanyRegistrationDocumentAttachment);
        setISO9001DocumentAttachment(ISO9001DocumentAttachment);
        setFactoryLicenceDocumentAttachment(FactoryLicenceDocumentAttachment);
        setISO4001DocumentAttachment(ISO4001DocumentAttachment);
        setISO26001DocumentAttachment(ISO26001DocumentAttachment);
        setOtherCertificationDocumentAttachment(OtherCertificationDocumentAttachment);
        setAssociationDocumentAttachment(AssociationDocumentAttachment);
        setPartnershipDeedDocumentAttachment(PartnershipDeedDocumentAttachment);
        setTrustDeedDocumentAttachment(TrustDeedDocumentAttachment);

        setOtherAgreementDocumentAttachment(OtherAgreementDocumentAttachment);
        setAnyDocumentDocumentAttachment(AnyDocumentDocumentAttachment);

        let taxationData = {
            ...taxationStatutoryDetails,
            PhotographOfEstablishAttachment,
            PFRegistrationDocumentAttachment,
            ESIRegistrationDocumentAttachment,
            YourOrganizationDocumentAttachment,
            PanNoDocumentAttachment,
            GSTINDocumentAttachment,
            VendorCodeOfConductAttachment,
            ProductSourcingDocumentAttachment,
            ExportLicenseDocumentAttachment,
            CompanyRegistrationDocumentAttachment,
            ISO9001DocumentAttachment,
            FactoryLicenceDocumentAttachment,
            ISO4001DocumentAttachment,
            ISO26001DocumentAttachment,
            OtherCertificationDocumentAttachment,
            AssociationDocumentAttachment,
            PartnershipDeedDocumentAttachment,
            TrustDeedDocumentAttachment,
            OtherAgreementDocumentAttachment,
            AnyDocumentDocumentAttachment,
            Pdagreement: taxationStatutoryDetails?.Pdagreement,
            IsPFRegistration: taxationStatutoryDetails?.IsPFRegistration?.toString(),
            IsESIRegistration: taxationStatutoryDetails?.IsESIRegistration?.toString(),
            IsYourOrganization: taxationStatutoryDetails?.IsYourOrganization?.toString(),
            IsGSTIN: taxationStatutoryDetails?.IsGSTIN?.toString(),
            ISO9001: taxationStatutoryDetails?.ISO9001?.toString(),
            IsFactoryLicence: taxationStatutoryDetails?.IsFactoryLicence?.toString(),
            IsPanNO: taxationStatutoryDetails?.IsPanNO?.toString(),
            ISO4001: taxationStatutoryDetails?.ISO4001?.toString(),
            ISO26001: taxationStatutoryDetails?.ISO26001?.toString(),
            ISOTSCertificationsOther: taxationStatutoryDetails?.ISOTSCertificationsOther?.toString(),
            YearOfBusinessIncorporation: !!taxationStatutoryDetails?.YearOfBusinessIncorporation ? {
                label: taxationStatutoryDetails?.YearOfBusinessIncorporationName,
                value: taxationStatutoryDetails?.YearOfBusinessIncorporation
            } : null,
            MsmeType: !!taxationStatutoryDetails?.MsmeType ? {
                label: taxationStatutoryDetails?.MsmeTypeName,
                value: taxationStatutoryDetails?.MsmeType
            } : null,
            MsmeCertificateRegistrationDate: taxationStatutoryDetails?.MsmeCertificateRegistrationDate ?
                new Date(taxationStatutoryDetails?.MsmeCertificateRegistrationDate) : null,
            FactoryLicenceExpiryDate: taxationStatutoryDetails?.FactoryLicenceExpiryDate ?
                new Date(taxationStatutoryDetails?.FactoryLicenceExpiryDate) : null,
            ISO4001Expirydate: taxationStatutoryDetails?.ISO4001Expirydate ?
                new Date(taxationStatutoryDetails?.ISO4001Expirydate) : null,
            ISO26001Expirydate: taxationStatutoryDetails?.ISO26001Expirydate ?
                new Date(taxationStatutoryDetails?.ISO26001Expirydate) : null,
            OtherCertificationExpiryDate: taxationStatutoryDetails?.OtherCertificationExpiryDate ?
                new Date(taxationStatutoryDetails?.OtherCertificationExpiryDate) : null,
            ISO9001ExpiryDate: taxationStatutoryDetails?.ISO9001ExpiryDate ?
                new Date(taxationStatutoryDetails?.ISO9001ExpiryDate) : null,
        }
        if (taxationStatutoryDetails?.IsGSTIN?.toString() == "true" && taxationStatutoryDetails?.GSTIN) {
            setIsGstValid(true)
        }
        reset(taxationData)
        hidePageLoader()
    }

    useEffect(() => {
        if (supplierDetail?.TaxationStatutoryDetails) {
            setTaxationFormEdit(supplierDetail?.TaxationStatutoryDetails)
        }
        handleCountryStateChange(supplierDetail?.KYS1ContactDetails?.VendorWorkAddressDetail?.CountryId)

    }, [supplierDetail])


    const getYearOfBusInessCorporation = () => {
        getYearOfBuisnessService()
            .then((res) => {
                if (res?.IsSuccessful) {
                    let list = res?.Data?.map(el => ({ label: el.Name, value: el.Id }));
                    setYearOfBusinessIncorporation(list);
                }
            })
            .catch(() => { });
    };

    const getMSMEList = () => {
        axiosHelper.get(`${API.getMSMEList}`).then((response) => {
            if (response.data.IsSuccessful) {
                let list = response?.data?.Data?.map(el => ({ label: el.Name, value: el.Id }));
                setMSMEList(list)
            }
        })
            .catch((error) => {
                apiErrors(error);
                throw error; // Re-throw the error to the caller
            });
    }

    const getSpecializationList = () => {
        axiosHelper.get(`${API.getSpecializationList}`).then((response) => {
            if (response.data.IsSuccessful) {
                let list = response?.data?.Data?.map(el => ({ label: el?.SpecializationName?.trim(), value: el.Id }));
                setSpecializationList(list)
            }
        })
            .catch((error) => {
                apiErrors(error);
                throw error; // Re-throw the error to the caller
            });
    }

    const handleAttachmentUpload = (file, fileIdentifier, setCurrentFile, formFieldKey) => {
        const currentFileConfiguration = fileConfig[fileIdentifier];

        // Check for spaces and special characters in filename
        const hasSpecialChars = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/.test(file.name);
        const hasSpaces = /\s/.test(file.name);

        if (hasSpaces || hasSpecialChars) {
            setValue(formFieldKey, null);
            notify.error(
                "Error uploading file. File name should not contain spaces or special characters. Please rename the file and try again."
            );
            return;
        }

        if (file.size <= (currentFileConfiguration.maxSize * 1024 * 1024)) {
            const reader = new FileReader();
            reader.onload = (event) => {
                let base64String = event.target.result;
                // Remove the data type prefix
                base64String = base64String.replace(/^data:(.*?);base64,/, "");
                // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
                const allowedFileTypes = currentFileConfiguration.allowedFileTypes;
                const isTypeValid = allowedFileTypes?.includes(file.type);
                if (!isTypeValid) {
                    // Handle the case where the file type is not allowed
                    notify.error(currentFileConfiguration.validationMessage);
                    setValue(formFieldKey, null)
                    return;
                } else {
                    // Pass file name, base64String, and fileType to setGstinFile
                    let selectedFile = { fileName: file.name, base64String, fileType: file.type };
                    setCurrentFile(selectedFile);
                    setValue(formFieldKey, selectedFile)
                    trigger(formFieldKey)
                }
            };
            reader.readAsDataURL(file);
        } else {
            // Handle the case where the file size exceeds 5 MB
            setValue(formFieldKey, null)
            notify.error(`File size exceeds ${currentFileConfiguration.maxSize} MB. Please choose a smaller file.`);
        }
    };
    async function handleCountryStateChange(selectedValue) {
        console.log('selectedValue: ', selectedValue);
        const stateRes = await getStateSelection(
            selectedValue
        );
        setOptionData(stateRes?.Data?.StateList);
        // if (emptyOther) {
        //     setValue("State", null);
    }
    const checkStateForGSTIN = () => {
        const GISTINNumber = getValues("GSTIN");
        console.log('GISTINNumber: ', GISTINNumber);
        const currentState = supplierDetail?.KYS1ContactDetails?.VendorWorkAddressDetail?.StateId;
        let selectedState = stateOptionData.find(state => state?.Id == currentState);
        console.log('selectedState: ', selectedState);
        if (GISTINNumber && selectedState) {
            return selectedState.GSTCode == GISTINNumber.substring(0, 2);
        }
    };
    const onSubmitTaxationStatutory = (values) => {
        const GSTIN = values?.GSTIN;
        const isGstFilled = values?.IsGSTIN;
        if (GSTIN && !checkStateForGSTIN(GSTIN) && supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1) {
            notify.error("Please select the correct state for provided GSTIN Number");
            return;
        }
        if (!isGstValid && GSTIN && (isGstFilled == "true") && supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1) {
            setError('GSTIN', {
                type: 'manual',
                message: "The provided GSTIN number is invalid.",
            });
            return;
        }
        
        let payload = cloneDeep(values);
        if (values.IsYourOrganization === 'false' || values.IsYourOrganization === false) {
            payload.YourOrganizationRegistrationNumber = null;
            payload.MsmeCertificateRegistrationDate = null;
            payload.MsmeType = null;
            // Set additional fields to null or their default values as necessary
        }
        payload.KYS1RegistrationId = supplierDetail?.TaxationStatutoryDetails?.KYS1RegistrationId;
        payload.PhotographOfEstablishAttachment = photographOfEstablishAttachment;

        payload.YearOfBusinessIncorporation = values?.YearOfBusinessIncorporation?.value;
        payload.MsmeType = values?.MsmeType?.value;
        if (!supplierDetail?.TaxationStatutoryDetails?.IsPSARequired) {
            payload.Pdagreement = false;
        }
        setShowTabLoader(true);
        axiosHelper.post(API.addAndUpdateKYS1TaxationStatutoryDetail, payload)
            .then((response) => {
                if (response.data.IsSuccessful) {
                    notify.success(response?.data?.Data?.Message)
                    props.toggleKys1FormTabs("4")
                    hidePageLoader()
                }
            })
            .catch((error) => {
                hidePageLoader();
                if (error.response.status === 401) {
                    apiErrors(error)
                } else {

                    if (!error?.response?.data?.IsSuccessful) {
                        notify.error(error?.response?.data?.ErrorMessage)
                    }
                }
            });
    };

    const validateGSTIN = async (gstNumber, notifyMsg = true) => {
        if (gstNumber) {
            setShowTabLoader(true);
            gstNumber = gstNumber.toUpperCase();
            let url = `${API.GSTValidate}?GSTIN=${gstNumber}`;
            const request = axiosHelper.get(url);
            request
                .then((response) => {
                    if (response.data.IsSuccessful) {
                        setIsGstValid(true);
                        setShowTabLoader(false);
                        if (notifyMsg) {
                            notify.success(response.data.FriendlyMessage);
                        }
                    }
                })
                .catch((error) => {
                    if (error.response.status === 401) {
                        apiErrors(error)
                    }else{

                        if (error.response && error.response.status === 400) {
                            const responseData = error.response.data;
                            if (!responseData.IsSuccessful) {
                                setIsGstValid(false);
                                setShowTabLoader(false);
                                setError('GSTIN', {
                                    type: 'manual',
                                    message: responseData.FriendlyMessage,
                                });
                                return false;
                            }
                        }
                    }
                });
        }
    };

    const validatePANByGstin = (value) => {
        const PanNumber = getValues("PanNumber"); // Get GSTIN value from the first input field
        const gstinPAN = value?.substring(2, 12); // Extract PAN from GSTIN
        if (PanNumber !== gstinPAN && PanNumber && value) {
            return "GSTIN and PAN number do not match.";
        }
        return true;
    };


    const getRegistrationCertificateLabel = (companyTypeId, domesticandOverseas) => {
        if (domesticandOverseas == 2) {
            return (
                <>
                    Unified Social Credit Identifier (USCI)/ Business Licence Number
                    <TooltipCustom id="RegistrationTooltip"
                        tooltipText="Please attach copy of Registration/License"
                    />
                </>
            )
        }
        if (companyTypeId == 1) {
            return `Enter CIN Number`
        }
        if (companyTypeId == 6) {
            return `Enter OPC Number`
        }
        if (companyTypeId == 4) {
            return `Enter LLP Number`
        }
    }

    return (
        <>
            {showTabLoader && (<LoaderCustom customClass="simulation-Loader" />)}
            <div className='hl-taxation-wrap'>
                {
                    !supplierDetail?.IsKYS1Editable && (
                        <div className='disableKys1Form'>  </div>
                    )
                }
                <form onSubmit={handleSubmit(onSubmitTaxationStatutory)}>
                    <Row className="part-detail-wrapper">
                        <Col md="4">
                            <SearchableSelectHookForm
                                // {...register("YearOfBusinessIncorporation")}
                                register={register}
                                name="YearOfBusinessIncorporation"
                                options={yearOfBusinessIncorporation}
                                label="Year of Incorporation"
                                rules={{ required: true }}
                                placeholder="Select"
                                Controller={Controller}
                                control={control}
                                mandatory={true}
                                errors={errors?.YearOfBusinessIncorporation}
                                disabled={false}
                                handleChange={() => { }}
                            />
                        </Col>
                        <Col md="12"><hr className="hr-seprator mt-2" /></Col>
                    </Row>
                    <Row className="part-detail-wrapper">
                        <Col md="4" className='d-flex'>
                            <Label className='hl-title-tooltip'>
                                Photograph of Establishment
                                <span className="asterisk-required">*</span>
                                <TooltipCustom id="photoTooltip"
                                    tooltipText="Please attach latest photograph with reflecting Establishment name plate/board"
                                />
                            </Label>
                            <div className='mw-120 text-right'>
                                <FileUpload
                                    control={control}
                                    uploadClass="hl-iso-upload mt-1 ml-0"
                                    {...register("PhotographOfEstablishAttachment")}
                                    onFileChange={(file) => handleAttachmentUpload(file, "common", setPhotographOfEstablishAttachment, "PhotographOfEstablishAttachment")}
                                    onDelete={() => {
                                        setValue("PhotographOfEstablishAttachment", null);
                                        setPhotographOfEstablishAttachment(p => ({ ...p, isRemove: true }))
                                    }}
                                    uploadedFile={photographOfEstablishAttachment}
                                    setUploadedFile={setPhotographOfEstablishAttachment}
                                    allowedFileTypes={fileConfig.common.allowedFileTypes}
                                    rules={{ required: "File required" }}
                                    mandatory={true}
                                    errors={errors?.PhotographOfEstablishAttachment}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="part-detail-wrapper mb-3">
                        <Col md="12" className={(
                            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 2 ||
                            (
                                supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 &&
                                llpOpcCompanyEstablishment.includes(supplierDetail?.KYS1ContactDetails?.RegistrationDetail.CompanyTypeId)
                            )
                        ) ? "" : "d-none"} ><hr className="hr-seprator mt-2" /> </Col>
                        <Col md="4" xxl='3' className={(
                            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 2 ||
                            (
                                supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 &&
                                llpOpcCompanyEstablishment.includes(supplierDetail?.KYS1ContactDetails?.RegistrationDetail.CompanyTypeId)
                            )
                        ) ? "d-flex align-items-center" : "d-flex align-items-center d-none"}>
                            {
                                (
                                    (
                                        supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 2 ||
                                        (
                                            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 &&
                                            llpOpcCompanyEstablishment.includes(supplierDetail?.KYS1ContactDetails?.RegistrationDetail.CompanyTypeId)
                                        )
                                    )

                                ) && (
                                    <div className='fullinput-icon'>
                                        <TextFieldHookForm
                                            register={register}
                                            name="CompanyRegistrationNumber"
                                            label={
                                                getRegistrationCertificateLabel(supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.CompanyTypeId, supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas)
                                            }
                                            Controller={Controller}
                                            control={control}
                                            placeholder={"Enter"}
                                            rules={{
                                                //required for all overseas company type, but if indian then for only llp, opc, company
                                                required: true,
                                                maxLength: 21,
                                                validate: { checkWhiteSpaces }
                                            }}
                                            customClassName={"withBorder mb-0"}
                                            handleChange={(e) => {
                                                const uppercaseValue = e.target.value.toUpperCase();
                                                e.target.value = uppercaseValue;
                                            }}
                                            errors={errors?.CompanyRegistrationNumber}
                                            disabled={false}
                                            mandatory={true}
                                        />
                                    </div>
                                )
                            }
                            {
                                (
                                    supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 2 ||
                                    (
                                        supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 &&
                                        llpOpcCompanyEstablishment.includes(supplierDetail?.KYS1ContactDetails?.RegistrationDetail.CompanyTypeId)
                                    )
                                ) && (
                                    <FileUpload
                                        uploadClass="mt-4 hl-mb-0"
                                        uploaMainWrap="pt-1"
                                        control={control}
                                        {...register("CompanyRegistrationDocumentAttachment")}
                                        onFileChange={(file) => handleAttachmentUpload(file, "common", setCompanyRegistrationDocumentAttachment, "CompanyRegistrationDocumentAttachment")}
                                        onDelete={() => {
                                            setValue("CompanyRegistrationDocumentAttachment", null);
                                            setCompanyRegistrationDocumentAttachment(p => ({ ...p, isRemove: true }))
                                        }}
                                        uploadedFile={companyRegistrationDocumentAttachment}
                                        setUploadedFile={setCompanyRegistrationDocumentAttachment}
                                        allowedFileTypes={fileConfig.common.allowedFileTypes}
                                        rules={{
                                            required: "File required"
                                        }}
                                        mandatory={true}
                                        errors={errors?.CompanyRegistrationDocumentAttachment}
                                    />
                                )
                            }
                        </Col>
                        {
                            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 && (
                                <>
                                    <Col md="12"><hr className="hr-seprator mt-3" /></Col>
                                    <Col md="3">
                                        <Label className='hl-title-tooltip'>PAN Number<span className="asterisk-required">*</span>
                                            <TooltipCustom id="PANTooltip"
                                                tooltipText="Please attach copy of PAN Card"
                                            />
                                        </Label>
                                        <Label className={"d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pt-0 radio-box"} check>
                                            <input
                                                type="radio"
                                                // {...register("IsPanNO")}
                                                // rules={{ required: true }}
                                                {...register("IsPanNO", { required: radioValidateMsg })}
                                                className="zero-based"
                                                value={true}
                                            // defaultChecked
                                            />
                                            <span>Yes</span>
                                        </Label>
                                        <Label
                                            className={
                                                "d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                            }
                                            check
                                        >
                                            <input
                                                type="radio"
                                                // {...register("IsPanNO")}
                                                // rules={{ required: true }}
                                                {...register("IsPanNO", { required: radioValidateMsg })}
                                                className="vendor-based"
                                                value={false}
                                            />
                                            <span>No</span>
                                        </Label>
                                        {errors?.IsPanNO && (
                                            <div className="text-help">
                                                {errors?.IsPanNO?.message}
                                            </div>
                                        )}
                                        <Row>
                                            {
                                                watch("IsPanNO") === "true" && (
                                                    <Col md="12">
                                                        <div className="d-flex align-items-center">
                                                            <div className="fullinput-icon">
                                                                <TextFieldHookForm
                                                                    register={register}
                                                                    name="PanNumber"
                                                                    label={false}
                                                                    Controller={Controller}
                                                                    control={control}
                                                                    placeholder={"Enter"}
                                                                    rules={{
                                                                        required: true,
                                                                        maxLength: 10,
                                                                        minLength: {
                                                                            value: 10,
                                                                            message: "Minimum length is 10",
                                                                        },
                                                                        validate: { checkWhiteSpaces, alphaNumeric, isValidPAN },
                                                                    }}
                                                                    customClassName={"withBorder mb-0"}
                                                                    handleChange={(e) => {
                                                                        // Convert input value to uppercase
                                                                        const uppercaseValue = e.target.value.toUpperCase();
                                                                        e.target.value = uppercaseValue;
                                                                    }}
                                                                    errors={errors?.PanNumber}
                                                                    disabled={false}
                                                                    mandatory={true}
                                                                />
                                                            </div>
                                                            <FileUpload
                                                                control={control}
                                                                uploadClass="mt-0 hl-mb-0"
                                                                {...register("PanNoDocumentAttachment")}
                                                                onFileChange={(file) => handleAttachmentUpload(file, "common", setPanNoDocumentAttachment, "PanNoDocumentAttachment")}
                                                                onDelete={() => {
                                                                    setValue("PanNoDocumentAttachment", null);
                                                                    setPanNoDocumentAttachment(p => ({ ...p, isRemove: true }))
                                                                }}
                                                                uploadedFile={panNoDocumentAttachment}
                                                                setUploadedFile={setPanNoDocumentAttachment}
                                                                allowedFileTypes={fileConfig.common.allowedFileTypes}
                                                                rules={{ required: "File required" }}
                                                                mandatory={true}
                                                                errors={errors?.PanNoDocumentAttachment}
                                                            />
                                                        </div>
                                                    </Col>
                                                )
                                            }
                                            {
                                                watch("IsPanNO") === "false" &&
                                                (
                                                    <Col md="12">
                                                        <TextAreaHookForm
                                                            register={register}
                                                            name="PanRemark"
                                                            label={`Remark`}
                                                            Controller={Controller}
                                                            control={control}
                                                            placeholder={"Enter"}
                                                            rules={{
                                                                required: true,
                                                                maxLength: 250,
                                                                validate: { checkWhiteSpaces },
                                                                minLength: {
                                                                    value: 20,
                                                                    message: "Minimum length is 20",
                                                                },
                                                            }}
                                                            customClassName={"withBorder mb-0"}
                                                            handleChange={() => { }}
                                                            errors={errors?.PanRemark}
                                                            disabled={false}
                                                            mandatory={true}
                                                        />
                                                    </Col>
                                                )
                                            }
                                        </Row>
                                    </Col>
                                    <Col md="3">
                                        <Label>
                                            GSTIN Number
                                            <span className="asterisk-required">*</span>
                                        </Label>
                                        <Label className={"d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pt-0 radio-box"} check>
                                            <input
                                                type="radio"
                                                // {...register("IsGSTIN")}
                                                // rules={{ required: true }}
                                                {...register("IsGSTIN", { required: radioValidateMsg })}
                                                className="zero-based"
                                                value={true}
                                            // defaultChecked
                                            />
                                            <span>Yes</span>
                                        </Label>
                                        <Label
                                            className={
                                                "d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                            }
                                            check
                                        >
                                            <input
                                                type="radio"
                                                // {...register("IsGSTIN")}
                                                // rules={{ required: true }}
                                                {...register("IsGSTIN", { required: radioValidateMsg })}
                                                className="vendor-based"
                                                value={false}
                                            />
                                            <span>No</span>
                                        </Label>
                                        {errors?.IsGSTIN && (
                                            <div className="text-help">
                                                {errors?.IsGSTIN?.message}
                                            </div>
                                        )}
                                        <Row>
                                            {
                                                watch("IsGSTIN") === "true" && (
                                                    <Col md="12">
                                                        <div className="d-flex align-items-center">
                                                            <div className="fullinput-icon">
                                                                <TextFieldHookForm
                                                                    register={register}
                                                                    name="GSTIN"
                                                                    label={false}
                                                                    Controller={Controller}
                                                                    control={control}
                                                                    placeholder={"Enter"}
                                                                    rules={{
                                                                        required: true,
                                                                        validate: {
                                                                            checkWhiteSpaces,
                                                                            validatePANByGstin
                                                                        },
                                                                        maxLength: 15,
                                                                        minLength: {
                                                                            value: 15,
                                                                            message: "Minimum length is 15 digits.",
                                                                        },
                                                                    }}
                                                                    customClassName={"withBorder mb-0"}
                                                                    handleChange={(e) => {
                                                                        setIsGstValid(false);
                                                                        setHasGSTINChanged(true);
                                                                        const uppercaseValue = e.target.value.toUpperCase();
                                                                        e.target.value = uppercaseValue;
                                                                    }}
                                                                    errors={errors?.GSTIN}
                                                                    disabled={false}
                                                                    mandatory={true}
                                                                    onFieldBlur={(e) => {
                                                                        if (hasGSTINChanged) {
                                                                            validateGSTIN(e.target.value);
                                                                            setHasGSTINChanged(false);
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <FileUpload
                                                                control={control}
                                                                uploadClass="mt-1 hl-mb-0"
                                                                {...register("GSTINDocumentAttachment")}
                                                                onFileChange={(file) => handleAttachmentUpload(file, "common", setGSTINDocumentAttachment, "GSTINDocumentAttachment")}
                                                                onDelete={() => {
                                                                    setValue("GSTINDocumentAttachment", null);
                                                                    setGSTINDocumentAttachment(p => ({ ...p, isRemove: true }))
                                                                }}
                                                                uploadedFile={gstinDocumentAttachment}
                                                                setUploadedFile={setGSTINDocumentAttachment}
                                                                allowedFileTypes={fileConfig.common.allowedFileTypes}
                                                                rules={{ required: "File required" }}
                                                                mandatory={true}
                                                                errors={errors?.GSTINDocumentAttachment}
                                                            />
                                                        </div>
                                                    </Col>
                                                )
                                            }
                                            {
                                                watch("IsGSTIN") === "false" &&
                                                (
                                                    <Col md="12">
                                                        <TextAreaHookForm
                                                            register={register}
                                                            name="GSTINRemark"
                                                            label={`Remark`}
                                                            Controller={Controller}
                                                            control={control}
                                                            placeholder={"Enter"}
                                                            rules={{
                                                                required: true,
                                                                maxLength: 250,
                                                                validate: { checkWhiteSpaces },
                                                                minLength: {
                                                                    value: 20,
                                                                    message: "Minimum length is 20",
                                                                },
                                                            }}
                                                            customClassName={"withBorder mb-0"}
                                                            handleChange={() => { }}
                                                            errors={errors?.GSTINRemark}
                                                            disabled={false}
                                                            mandatory={true}
                                                        />
                                                    </Col>
                                                )
                                            }
                                        </Row>
                                    </Col>
                                </>
                            )
                        }
                    </Row>
                    {
                        supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 && (
                            <>
                                <Row className="part-detail-wrapper">
                                    <Col md="12"><hr className="hr-seprator mb-3" /></Col>
                                    <Col md="4">
                                        <Label>PF Registration Number <span className="asterisk-required">*</span></Label>
                                        <Label className={"d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pt-0 radio-box"} check>
                                            <input
                                                type="radio"
                                                // rules={{ required: true }}
                                                // {...register("IsPFRegistration")}
                                                {...register("IsPFRegistration", { required: radioValidateMsg })}
                                                className="zero-based"
                                                value={true}
                                            // defaultChecked
                                            />
                                            <span>Yes</span>
                                        </Label>
                                        <Label
                                            className={
                                                "d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                            }
                                            check
                                        >
                                            <input
                                                type="radio"
                                                // rules={{ required: true }}
                                                // {...register("IsPFRegistration")}
                                                {...register("IsPFRegistration", { required: radioValidateMsg })}
                                                className="vendor-based"
                                                value={false}
                                            />
                                            <span>No</span>
                                        </Label>
                                        {errors?.IsPFRegistration && (
                                            <div className="text-help">
                                                {errors?.IsPFRegistration?.message}
                                            </div>
                                        )}
                                        <Row>
                                            {
                                                watch("IsPFRegistration") === "true" && (
                                                    <Col md="12">
                                                        <div className="d-flex align-items-center">
                                                            <div className="fullinput-icon">
                                                                <TooltipCustom id="PFTooltip"
                                                                    tooltipText="Please attach latest copy of PF Registration Certificate"
                                                                />
                                                                <TextFieldHookForm
                                                                    register={register}
                                                                    name="PFRegistrationNumber"
                                                                    label={`PF Number`}
                                                                    Controller={Controller}
                                                                    control={control}
                                                                    placeholder={"Enter"}
                                                                    rules={{
                                                                        required: true,
                                                                        maxLength: 22,
                                                                        validate: { checkWhiteSpaces },
                                                                    }}
                                                                    customClassName={"withBorder mb-0"}
                                                                    handleChange={(e) => {
                                                                        // Convert input value to uppercase
                                                                        const uppercaseValue = e.target.value.toUpperCase();
                                                                        e.target.value = uppercaseValue;
                                                                    }}
                                                                    errors={errors?.PFRegistrationNumber}
                                                                    disabled={false}
                                                                    mandatory={true}
                                                                />
                                                            </div>
                                                            <FileUpload
                                                                control={control}
                                                                uploadClass="mt-4 hl-mb-0"
                                                                {...register("PFRegistrationDocumentAttachment")}
                                                                onFileChange={(file) => handleAttachmentUpload(file, "common", setPFRegistrationDocumentAttachment, "PFRegistrationDocumentAttachment")}
                                                                onDelete={() => {
                                                                    setValue("PFRegistrationDocumentAttachment", null);
                                                                    setPFRegistrationDocumentAttachment(p => ({ ...p, isRemove: true }))
                                                                }}
                                                                uploadedFile={pfRegistrationDocumentAttachment}
                                                                setUploadedFile={setPFRegistrationDocumentAttachment}
                                                                allowedFileTypes={fileConfig.common.allowedFileTypes}
                                                                rules={{ required: "File required" }}
                                                                mandatory={true}
                                                                errors={errors?.PFRegistrationDocumentAttachment}
                                                            />
                                                        </div>
                                                    </Col>
                                                )
                                            }
                                            {
                                                watch("IsPFRegistration") === "false" &&
                                                (
                                                    <Col md="12">
                                                        <TextAreaHookForm
                                                            // {...register("PFRemark")}
                                                            register={register}
                                                            name="PFRemark"
                                                            label={`Remark`}
                                                            Controller={Controller}
                                                            control={control}
                                                            placeholder={"Enter"}
                                                            rules={{
                                                                required: true,
                                                                maxLength: 250,
                                                                validate: { checkWhiteSpaces },
                                                                minLength: {
                                                                    value: 20,
                                                                    message: "Minimum length is 20",
                                                                },
                                                            }}
                                                            customClassName={"withBorder mb-0"}
                                                            handleChange={() => { }}
                                                            errors={errors?.PFRemark}
                                                            disabled={false}
                                                            mandatory={true}
                                                        />
                                                    </Col>
                                                )
                                            }
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="part-detail-wrapper">
                                    <Col md="12"><hr className="hr-seprator mt-2" /></Col>
                                    <Col md="4">
                                        <Label>ESI Registration Number<span className="asterisk-required">*</span></Label>
                                        <Label
                                            className={
                                                "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pt-0 radio-box"
                                            }
                                            check
                                        >
                                            <input
                                                type="radio"
                                                // {...register("IsESIRegistration")}
                                                // rules={{ required: true }}
                                                {...register("IsESIRegistration", { required: radioValidateMsg })}
                                                className="zero-based"
                                                value={true}
                                            // defaultChecked
                                            />
                                            <span>Yes</span>
                                        </Label>
                                        <Label
                                            className={
                                                "d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                            }
                                            check
                                        >
                                            <input
                                                type="radio"
                                                // {...register("IsESIRegistration")}
                                                // rules={{ required: true }}
                                                {...register("IsESIRegistration", { required: radioValidateMsg })}
                                                className="vendor-based"
                                                value={false}
                                            />
                                            <span>No</span>
                                        </Label>
                                        {errors?.IsESIRegistration && (
                                            <div className="text-help">
                                                {errors?.IsESIRegistration?.message}
                                            </div>
                                        )}
                                        <Row>
                                            {
                                                watch("IsESIRegistration") === "true" && (
                                                    <Col md="12">
                                                        <div className="d-flex align-items-center">
                                                            <div className="fullinput-icon">
                                                                <TooltipCustom id="ESITooltip"
                                                                    tooltipText="Please attach latest copy of ESI Registration Certificate"
                                                                />
                                                                <TextFieldHookForm
                                                                    register={register}
                                                                    name="ESIRegistrationNumber"
                                                                    label={`ESI Number`}
                                                                    Controller={Controller}
                                                                    control={control}
                                                                    placeholder={"Enter"}
                                                                    rules={{
                                                                        required: true,
                                                                        maxLength: 17,
                                                                        validate: { checkWhiteSpaces },

                                                                    }}
                                                                    customClassName={"withBorder mb-0"}
                                                                    handleChange={(e) => {
                                                                        // Convert input value to uppercase
                                                                        const uppercaseValue = e.target.value.toUpperCase();
                                                                        e.target.value = uppercaseValue;
                                                                    }}
                                                                    errors={errors?.ESIRegistrationNumber}
                                                                    disabled={false}
                                                                    mandatory={true}
                                                                />
                                                            </div>
                                                            <FileUpload
                                                                control={control}
                                                                uploadClass="mt-4 hl-mb-0"
                                                                {...register("ESIRegistrationDocumentAttachment")}
                                                                onFileChange={(file) => handleAttachmentUpload(file, "common", setESIRegistrationDocumentAttachment, "ESIRegistrationDocumentAttachment")}
                                                                onDelete={() => {
                                                                    setValue("ESIRegistrationDocumentAttachment", null);
                                                                    setESIRegistrationDocumentAttachment(p => ({ ...p, isRemove: true }))
                                                                }}
                                                                uploadedFile={esiRegistrationDocumentAttachment}
                                                                setUploadedFile={setESIRegistrationDocumentAttachment}
                                                                allowedFileTypes={fileConfig.common.allowedFileTypes}
                                                                rules={{ required: "File required" }}
                                                                mandatory={true}
                                                                errors={errors?.ESIRegistrationDocumentAttachment}
                                                            />
                                                        </div>
                                                    </Col>
                                                )}
                                            {
                                                watch("IsESIRegistration") === "false" && (
                                                    <Col md="12">
                                                        <TextAreaHookForm
                                                            // {...register("ESIRemark")}
                                                            register={register}
                                                            name="ESIRemark"
                                                            label={`Remark`}
                                                            Controller={Controller}
                                                            control={control}
                                                            placeholder={"Enter"}
                                                            rules={{
                                                                required: true,
                                                                maxLength: 250,
                                                                validate: { checkWhiteSpaces },
                                                                minLength: {
                                                                    value: 20,
                                                                    message: "Minimum length is 20",
                                                                },
                                                            }}
                                                            customClassName={"withBorder mb-0"}
                                                            handleChange={() => { }}
                                                            errors={errors?.ESIRemark}
                                                            disabled={false}
                                                            mandatory={true}
                                                        />
                                                    </Col>
                                                )}
                                        </Row>
                                    </Col>
                                </Row>
                            </>
                        )
                    }
                    <hr className="hr-seprator" />
                    <Row className="part-detail-wrapper d-flex align-items-center">
                        <Col md="12">
                            <HeaderTitle
                                title={"Certificate Information:"}
                                customClass="mt-3"
                            />
                        </Col>
                    </Row>
                    <label className='text-danger mt-2'><strong>Note:</strong> All attached documents should be valid on the date of submission</label>
                    {
                        supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 && (
                            <Row className="part-detail-wrapper mb-3 mt-3">
                                <Col md="12">
                                    <Label className='hl-title-tooltip'>
                                        Is your Organization Registered under Micro, Small or Medium Enterprises (MSMED Act 2006)
                                        <span className="asterisk-required">*</span>
                                    </Label>
                                    <Label
                                        className={
                                            "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pt-0 radio-box"
                                        }
                                        check
                                    >
                                        <input
                                            type="radio"
                                            className="zero-based"
                                            // {...register("IsYourOrganization")}
                                            // rules={{ required: true }}
                                            {...register("IsYourOrganization", { required: radioValidateMsg })}
                                            value={true}
                                        // defaultChecked
                                        />
                                        <span>Yes</span>
                                    </Label>
                                    <Label
                                        className={
                                            "d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                        }
                                        check
                                    >
                                        <input
                                            type="radio"
                                            // {...register("IsYourOrganization")}
                                            // rules={{ required: true }}
                                            {...register("IsYourOrganization", { required: radioValidateMsg })}
                                            className="vendor-based2"
                                            value={false}
                                        />
                                        <span>No</span>
                                    </Label>
                                    {errors?.IsYourOrganization && (
                                        <div className="text-help">
                                            {errors?.IsYourOrganization?.message}
                                        </div>
                                    )}
                                    <Row>
                                        {
                                            watch("IsYourOrganization") === "true" && (
                                                <>
                                                    <Col md="4">
                                                        <div className="d-flex align-items-center">
                                                            <div className="fullinput-icon">
                                                                <TooltipCustom id="MicroTooltip"
                                                                    tooltipText="Please attach latest copy with latest date of Registration Certificate"
                                                                />
                                                                <TextFieldHookForm
                                                                    {...register("YourOrganizationRegistrationNumber")}
                                                                    label={`Registration Number`}
                                                                    Controller={Controller}
                                                                    control={control}
                                                                    placeholder={"Enter"}
                                                                    rules={{
                                                                        required: true,
                                                                        maxLength: 25,
                                                                        validate: { checkWhiteSpaces }
                                                                    }}
                                                                    customClassName={"withBorder mb-0"}
                                                                    handleChange={(e) => {
                                                                        // Convert input value to uppercase
                                                                        const uppercaseValue = e.target.value.toUpperCase();
                                                                        e.target.value = uppercaseValue;
                                                                    }}
                                                                    errors={errors?.YourOrganizationRegistrationNumber}
                                                                    disabled={false}
                                                                    mandatory={true}
                                                                />
                                                            </div>
                                                            <FileUpload
                                                                control={control}
                                                                uploadClass="mt-4 hl-mb-0"
                                                                {...register("YourOrganizationDocumentAttachment")}
                                                                onFileChange={(file) => handleAttachmentUpload(file, "common", setYourOrganizationDocumentAttachment, "YourOrganizationDocumentAttachment")}
                                                                onDelete={() => {
                                                                    setValue("YourOrganizationDocumentAttachment", null);
                                                                    setYourOrganizationDocumentAttachment(p => ({ ...p, isRemove: true }))
                                                                }}
                                                                uploadedFile={yourOrganizationDocumentAttachment}
                                                                setUploadedFile={setYourOrganizationDocumentAttachment}
                                                                allowedFileTypes={fileConfig.common.allowedFileTypes}
                                                                rules={{ required: "File required" }}
                                                                mandatory={true}
                                                                errors={errors?.YourOrganizationDocumentAttachment}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col md="2">
                                                        <SearchableSelectHookForm
                                                            {...register("MsmeType")}
                                                            options={MSMEList}
                                                            label={"MSME Type"}
                                                            rules={{ required: true }}
                                                            placeholder="Select"
                                                            Controller={Controller}
                                                            control={control}
                                                            mandatory={true}
                                                            errors={errors?.MsmeType}
                                                            handleChange={() => { }}
                                                        />
                                                    </Col>
                                                    <Col md="2">
                                                        <>
                                                            <div className="d-flex align-items-center">
                                                                <div className="fullinput-icon">
                                                                    <label>
                                                                        Registration Date
                                                                        <span className="asterisk-required">*</span>
                                                                    </label>
                                                                    <div className="inputbox date-section">
                                                                        <Controller
                                                                            control={control}
                                                                            name="MsmeCertificateRegistrationDate"
                                                                            rules={{ required: "This field is required" }}
                                                                            render={({ field }) => (
                                                                                <>
                                                                                    <DatePicker
                                                                                        placeholderText="Select Date"
                                                                                        onChange={(date) => field.onChange(date)}
                                                                                        selected={field.value}
                                                                                        showMonthDropdown
                                                                                        showYearDropdown
                                                                                        dropdownMode="select"
                                                                                        dateFormat="dd/MM/yyyy"
                                                                                        autoComplete="off"
                                                                                        disabledKeyboardNavigation
                                                                                        onChangeRaw={(e) => e.preventDefault()}
                                                                                        className='form-control hl-datepicker-date mh-inherit'
                                                                                        maxDate={new Date()}
                                                                                    />
                                                                                    {errors && <span className="text-help">{errors?.MsmeCertificateRegistrationDate?.message}</span>}
                                                                                </>
                                                                            )}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    </Col>
                                                </>
                                            )
                                        }
                                    </Row>
                                </Col>
                                <Col md="12"><hr className="hr-seprator mb-3" /></Col>
                            </Row>
                        )
                    }

                    <Row className="part-detail-wrapper  mb-3">
                        <Col md="12">
                            <Label>
                                Do you have a Factory License?
                                <span className="asterisk-required">*</span>
                            </Label>
                            <Label
                                className={
                                    "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pt-0 radio-box"
                                }
                                check
                            >
                                <input
                                    type="radio"
                                    className="zero-based"
                                    // {...register("IsFactoryLicence")}
                                    // rules={{ required: true }}
                                    {...register("IsFactoryLicence", { required: radioValidateMsg })}
                                    value={true}
                                // defaultChecked
                                />
                                <span>Yes</span>
                            </Label>
                            <Label
                                className={
                                    "d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                }
                                check
                            >
                                <input
                                    type="radio"
                                    // {...register("IsFactoryLicence")}
                                    // rules={{ required: true }}
                                    {...register("IsFactoryLicence", { required: radioValidateMsg })}
                                    className="vendor-based2"
                                    value={false}
                                    disabled={supplierDetail?.TaxationStatutoryDetails?.IsFactoryLicenceRequired}
                                />
                                <span>No</span>
                            </Label>
                            {errors?.IsFactoryLicence && (
                                <div className="text-help">
                                    {errors?.IsFactoryLicence?.message}
                                </div>
                            )}
                            <Row>
                                {
                                    watch("IsFactoryLicence") === "true" && (
                                        <>
                                            <Col md="4">
                                                <div className="d-flex align-items-center">
                                                    <div className="fullinput-icon">
                                                        <TextFieldHookForm
                                                            {...register("FactoryLicenceNumber")}
                                                            label={`Factory License Number`}
                                                            Controller={Controller}
                                                            control={control}
                                                            placeholder={"Enter"}
                                                            rules={{
                                                                required: true,
                                                                maxLength: 21,
                                                                validate: { checkWhiteSpaces }
                                                            }}
                                                            customClassName={"withBorder mb-0"}
                                                            handleChange={(e) => {
                                                                // Convert input value to uppercase
                                                                const uppercaseValue = e.target.value.toUpperCase();
                                                                e.target.value = uppercaseValue;
                                                            }}
                                                            errors={errors?.FactoryLicenceNumber}
                                                            disabled={false}
                                                            mandatory={true}
                                                        />
                                                    </div>
                                                    <FileUpload
                                                        control={control}
                                                        uploadClass="mt-4 hl-mb-0"
                                                        uploaMainWrap="pt-1"
                                                        {...register("FactoryLicenceDocumentAttachment")}
                                                        onFileChange={(file) => handleAttachmentUpload(file, "common", setFactoryLicenceDocumentAttachment, "FactoryLicenceDocumentAttachment")}
                                                        onDelete={() => {
                                                            setValue("FactoryLicenceDocumentAttachment", null);
                                                            setFactoryLicenceDocumentAttachment(p => ({ ...p, isRemove: true }))
                                                        }}
                                                        uploadedFile={factoryLicenceDocumentAttachment}
                                                        setUploadedFile={setFactoryLicenceDocumentAttachment}
                                                        allowedFileTypes={fileConfig.common.allowedFileTypes}
                                                        rules={{ required: "File required" }}
                                                        mandatory={true}
                                                        errors={errors?.FactoryLicenceDocumentAttachment}
                                                    />

                                                </div>
                                            </Col>
                                            <Col md="4">
                                                <div className="d-flex align-items-center">
                                                    <div className="fullinput-icon">
                                                        <label>
                                                            Expiry Date
                                                            <span className="asterisk-required">*</span>
                                                        </label>

                                                        <div className="inputbox date-section">
                                                            <Controller
                                                                control={control}
                                                                name="FactoryLicenceExpiryDate"
                                                                rules={{ required: "This field is required" }}
                                                                render={({ field }) => (
                                                                    <>
                                                                        <DatePicker
                                                                            placeholderText="Select Date"
                                                                            onChange={(date) => field.onChange(date)}
                                                                            selected={field.value}
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            dropdownMode="select"
                                                                            dateFormat="dd/MM/yyyy"
                                                                            autoComplete="off"
                                                                            disabledKeyboardNavigation
                                                                            onChangeRaw={(e) => e.preventDefault()}
                                                                            className='form-control hl-datepicker-date mh-inherit'
                                                                            minDate={tomorrowDate}
                                                                        />
                                                                        {errors && <span className="text-help">{errors?.FactoryLicenceExpiryDate?.message}</span>}
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </>
                                    )
                                }
                            </Row>
                        </Col>
                    </Row>

                    <Row className="part-detail-wrapper mb-3">
                        <Col md="12"><hr className="hr-seprator mb-3" /></Col>
                        <Col md="12">
                            <Label>Do you have ISO 9001/IATF 16949?<span className="asterisk-required">*</span></Label>
                            <Label
                                className={
                                    "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pt-0 radio-box"
                                }
                                check
                            >
                                <input
                                    type="radio"
                                    className="zero-based"
                                    // {...register("ISO9001")}
                                    // rules={{ required: true }}
                                    {...register("ISO9001", { required: radioValidateMsg })}
                                    value={true}
                                // defaultChecked
                                />
                                <span>Yes</span>
                            </Label>
                            <Label
                                className={
                                    "d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                }
                                check
                            >
                                <input
                                    type="radio"
                                    // {...register("ISO9001")}
                                    // rules={{ required: true }}
                                    {...register("ISO9001", { required: radioValidateMsg })}
                                    className="vendor-based2"
                                    value={false}
                                    disabled={supplierDetail?.TaxationStatutoryDetails?.IsISO9001Required}
                                />
                                <span>No</span>
                            </Label>
                            {errors?.ISO9001 && (
                                <div className="text-help">
                                    {errors?.ISO9001?.message}
                                </div>
                            )}
                            <Row>
                                {watch("ISO9001") === "true" && (
                                    <>
                                        <Col md="4">
                                            <div className="d-flex align-items-center">
                                                <div className="fullinput-icon">
                                                    <TextFieldHookForm
                                                        {...register("ISO9001Number")}
                                                        label={`Certificate Number`}
                                                        Controller={Controller}
                                                        control={control}
                                                        placeholder={"Enter"}
                                                        rules={{
                                                            required: true,
                                                            maxLength: 25,
                                                            validate: { checkWhiteSpaces }
                                                        }}
                                                        customClassName={"withBorder mb-0"}
                                                        handleChange={(e) => {
                                                            // Convert input value to uppercase
                                                            const uppercaseValue = e.target.value.toUpperCase();
                                                            e.target.value = uppercaseValue;
                                                        }}
                                                        errors={errors?.ISO9001Number}
                                                        disabled={false}
                                                        mandatory={true}
                                                    />
                                                </div>
                                                <FileUpload
                                                    control={control}
                                                    uploadClass="mt-4 hl-mb-0"
                                                    uploaMainWrap="pt-1"
                                                    {...register("ISO9001DocumentAttachment")}
                                                    onFileChange={(file) => handleAttachmentUpload(file, "common", setISO9001DocumentAttachment, "ISO9001DocumentAttachment")}
                                                    onDelete={() => {
                                                        setValue("ISO9001DocumentAttachment", null);
                                                        setISO9001DocumentAttachment(p => ({ ...p, isRemove: true }))
                                                    }}
                                                    uploadedFile={iso9001DocumentAttachment}
                                                    setUploadedFile={setISO9001DocumentAttachment}
                                                    allowedFileTypes={fileConfig.common.allowedFileTypes}
                                                    rules={{ required: "File required" }}
                                                    mandatory={true}
                                                    errors={errors?.ISO9001DocumentAttachment}
                                                />
                                            </div>
                                        </Col>
                                        <Col md="4">
                                            <div className="d-flex align-items-center">
                                                <div className="fullinput-icon">
                                                    <label>
                                                        Expiry Date
                                                        <span className="asterisk-required">*</span>
                                                    </label>

                                                    <div className="inputbox date-section">
                                                        <Controller
                                                            control={control}
                                                            name="ISO9001ExpiryDate"
                                                            rules={{ required: "This field is required" }}
                                                            render={({ field }) => (
                                                                <>
                                                                    <DatePicker
                                                                        placeholderText="Select Date"
                                                                        onChange={(date) => field.onChange(date)}
                                                                        selected={field.value}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        dropdownMode="select"
                                                                        dateFormat="dd/MM/yyyy"
                                                                        autoComplete="off"
                                                                        disabledKeyboardNavigation
                                                                        onChangeRaw={(e) => e.preventDefault()}
                                                                        className='form-control hl-datepicker-date mh-inherit'
                                                                        minDate={tomorrowDate}
                                                                    />
                                                                    {errors && <span className="text-help">{errors?.ISO9001ExpiryDate?.message}</span>}
                                                                </>
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </>
                                )
                                }
                            </Row>
                        </Col>
                        <Col md="12"><hr className="hr-seprator mt-4" /></Col>
                    </Row>

                    <Row className="part-detail-wrapper mb-3">
                        <Col md="12">
                            <Label>
                                Do you have ISO 14001?
                                <span className="asterisk-required">*</span>
                            </Label>
                            <Label
                                className={
                                    "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pt-0 radio-box"
                                }
                                check
                            >
                                <input
                                    type="radio"
                                    className="zero-based"
                                    // {...register("ISO4001")}
                                    // rules={{ required: true }}
                                    {...register("ISO4001", { required: radioValidateMsg })}
                                    value={true}
                                // defaultChecked
                                />
                                <span>Yes</span>
                            </Label>
                            <Label
                                className={
                                    "d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                }
                                check
                            >
                                <input
                                    type="radio"
                                    // {...register("ISO4001")}
                                    // rules={{ required: true }}
                                    {...register("ISO4001", { required: radioValidateMsg })}
                                    className="vendor-based2"
                                    value={false}
                                    disabled={supplierDetail?.TaxationStatutoryDetails?.IsISO4001Required}
                                />
                                <span>No</span>
                            </Label>
                            {errors?.ISO4001 && (
                                <div className="text-help">
                                    {errors?.ISO4001?.message}
                                </div>
                            )}
                            <Row>
                                {
                                    watch("ISO4001") === "true" && (
                                        <>
                                            <Col md="4">
                                                <div className="d-flex align-items-center">
                                                    <div className="fullinput-icon">
                                                        <TextFieldHookForm
                                                            {...register("ISO4001Number")}
                                                            label={`Certificate Number`}
                                                            Controller={Controller}
                                                            control={control}
                                                            placeholder={"Enter"}
                                                            rules={{
                                                                required: true,
                                                                maxLength: 25,
                                                                validate: { checkWhiteSpaces }
                                                            }}
                                                            customClassName={"withBorder mb-0"}
                                                            handleChange={(e) => {
                                                                // Convert input value to uppercase
                                                                const uppercaseValue = e.target.value.toUpperCase();
                                                                e.target.value = uppercaseValue;
                                                            }}
                                                            errors={errors?.ISO4001Number}
                                                            disabled={false}
                                                            mandatory={true}
                                                        />
                                                    </div>
                                                    <FileUpload
                                                        control={control}
                                                        uploadClass="mt-4 hl-mb-0"
                                                        uploaMainWrap="pt-1"
                                                        {...register("ISO4001DocumentAttachment")}
                                                        onFileChange={(file) => handleAttachmentUpload(file, "common", setISO4001DocumentAttachment, "ISO4001DocumentAttachment")}
                                                        onDelete={() => {
                                                            setValue("ISO4001DocumentAttachment", null);
                                                            setISO4001DocumentAttachment(p => ({ ...p, isRemove: true }))
                                                        }}
                                                        uploadedFile={iso4001DocumentAttachment}
                                                        setUploadedFile={setISO4001DocumentAttachment}
                                                        allowedFileTypes={fileConfig.common.allowedFileTypes}
                                                        rules={{ required: "File required" }}
                                                        mandatory={true}
                                                        errors={errors?.ISO4001DocumentAttachment}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md="4">
                                                <div className="d-flex align-items-center">
                                                    <div className="fullinput-icon">
                                                        <label>
                                                            Expiry Date
                                                            <span className="asterisk-required">*</span>
                                                        </label>

                                                        <div className="inputbox date-section">
                                                            <Controller
                                                                control={control}
                                                                name="ISO4001Expirydate"
                                                                rules={{ required: "This field is required" }}
                                                                render={({ field }) => (
                                                                    <>
                                                                        <DatePicker
                                                                            placeholderText="Select Date"
                                                                            onChange={(date) => field.onChange(date)}
                                                                            selected={field.value}
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            dropdownMode="select"
                                                                            dateFormat="dd/MM/yyyy"
                                                                            autoComplete="off"
                                                                            disabledKeyboardNavigation
                                                                            onChangeRaw={(e) => e.preventDefault()}
                                                                            className='form-control hl-datepicker-date mh-inherit'
                                                                            minDate={tomorrowDate}
                                                                        />
                                                                        {errors && <span className="text-help">{errors?.ISO4001Expirydate?.message}</span>}
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </>
                                    )
                                }
                            </Row>
                        </Col>
                        <Col md="12"><hr className="hr-seprator mt-4" /></Col>
                    </Row>
                    <Row className="part-detail-wrapper mb-3">

                        <Col md="12">
                            <Label>
                                Do you have ISO 26001?
                                <span className="asterisk-required">*</span>
                            </Label>

                            <Label
                                className={
                                    "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pt-0 radio-box"
                                }
                                check
                            >
                                <input
                                    type="radio"
                                    className="zero-based"
                                    // {...register("ISO26001")}
                                    // rules={{ required: true }}
                                    {...register("ISO26001", { required: radioValidateMsg })}
                                    value={true}
                                // defaultChecked
                                />
                                <span>Yes</span>
                            </Label>
                            <Label
                                className={
                                    "d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                }
                                check
                            >
                                <input
                                    type="radio"
                                    // {...register("ISO26001")}
                                    // rules={{ required: true }}
                                    {...register("ISO26001", { required: radioValidateMsg })}
                                    className="vendor-based2"
                                    value={false}
                                    disabled={supplierDetail?.TaxationStatutoryDetails?.IsISO26001Required}
                                />
                                <span>No</span>
                            </Label>
                            {errors?.ISO26001 && (
                                <div className="text-help">
                                    {errors?.ISO26001?.message}
                                </div>
                            )}
                            <Row>
                                {
                                    watch("ISO26001") === "true" && (
                                        <>
                                            <Col md="4">
                                                <div className="d-flex align-items-center">
                                                    <div className="fullinput-icon">
                                                        <TextFieldHookForm
                                                            {...register("ISO26001Number")}
                                                            label={`Certificate Number`}
                                                            Controller={Controller}
                                                            control={control}
                                                            placeholder={"Enter"}
                                                            rules={{
                                                                required: true,
                                                                maxLength: 25,
                                                                validate: { checkWhiteSpaces }
                                                            }}
                                                            customClassName={"withBorder mb-0"}
                                                            handleChange={(e) => {
                                                                // Convert input value to uppercase
                                                                const uppercaseValue = e.target.value.toUpperCase();
                                                                e.target.value = uppercaseValue;
                                                            }}
                                                            errors={errors?.ISO26001Number}
                                                            disabled={false}
                                                            mandatory={true}
                                                        />
                                                    </div>
                                                    <FileUpload
                                                        control={control}
                                                        uploadClass="mt-4 hl-mb-0"
                                                        uploaMainWrap="pt-1"
                                                        {...register("ISO26001DocumentAttachment")}
                                                        onFileChange={(file) => handleAttachmentUpload(file, "common", setISO26001DocumentAttachment, "ISO26001DocumentAttachment")}
                                                        onDelete={() => {
                                                            setValue("ISO26001DocumentAttachment", null);
                                                            setISO26001DocumentAttachment(p => ({ ...p, isRemove: true }))
                                                        }}
                                                        uploadedFile={iso26001DocumentAttachment}
                                                        setUploadedFile={setISO26001DocumentAttachment}
                                                        allowedFileTypes={fileConfig.common.allowedFileTypes}
                                                        rules={{ required: "File required" }}
                                                        mandatory={true}
                                                        errors={errors?.ISO26001DocumentAttachment}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md="4">
                                                <div className="d-flex align-items-center">
                                                    <div className="fullinput-icon">
                                                        <label>
                                                            Expiry Date
                                                            <span className="asterisk-required">*</span>
                                                        </label>

                                                        <div className="inputbox date-section">
                                                            <Controller
                                                                control={control}
                                                                name="ISO26001Expirydate"
                                                                rules={{ required: "This field is required" }}
                                                                render={({ field }) => (
                                                                    <>
                                                                        <DatePicker
                                                                            placeholderText="Select Date"
                                                                            onChange={(date) => field.onChange(date)}
                                                                            selected={field.value}
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            dropdownMode="select"
                                                                            dateFormat="dd/MM/yyyy"
                                                                            autoComplete="off"
                                                                            disabledKeyboardNavigation
                                                                            onChangeRaw={(e) => e.preventDefault()}
                                                                            className='form-control hl-datepicker-date mh-inherit'
                                                                            minDate={tomorrowDate}
                                                                        />
                                                                        {errors && <span className="text-help">{errors?.ISO26001Expirydate?.message}</span>}
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </>
                                    )
                                }
                            </Row>
                        </Col>
                        <Col md="12"><hr className="hr-seprator mt-4" /></Col>
                        {
                            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 2 && (
                                <Col md='4' className='d-flex align-items-center'>
                                    <Label>
                                        Export License
                                        <span className="asterisk-required">*</span>
                                    </Label>
                                    <div className='mw-120 text-right'>
                                        <FileUpload
                                            uploadClass={"mt-1 ml-0"}
                                            control={control}
                                            {...register("ExportLicenseDocumentAttachment")}
                                            onFileChange={(file) => handleAttachmentUpload(file, "common", setExportLicenseDocumentAttachment, "ExportLicenseDocumentAttachment")}
                                            onDelete={() => {
                                                setValue("ExportLicenseDocumentAttachment", null);
                                                setExportLicenseDocumentAttachment(p => ({ ...p, isRemove: true }))
                                            }}
                                            uploadedFile={exportLicenseDocumentAttachment}
                                            setUploadedFile={setExportLicenseDocumentAttachment}
                                            allowedFileTypes={fileConfig.common.allowedFileTypes}
                                            rules={{ required: "File required" }}
                                            mandatory={true}
                                            errors={errors?.ExportLicenseDocumentAttachment}
                                        />
                                    </div>
                                </Col>
                            )
                        }
                    </Row>

                    <Row className="part-detail-wrapper mb-3">
                        <Col md="12">
                            <Label>
                                Others (If any)
                            </Label>
                            <Label
                                className={
                                    "d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pt-0 radio-box"
                                }
                                check
                            >
                                <input
                                    type="radio"
                                    className="zero-based"
                                    {...register("ISOTSCertificationsOther")}
                                    value={true}
                                //This field is not required
                                // defaultChecked
                                />
                                <span>Yes</span>
                            </Label>
                            <Label
                                className={
                                    "d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                }
                                check
                            >
                                <input
                                    type="radio"
                                    {...register("ISOTSCertificationsOther")}
                                    className="vendor-based2"
                                    value={false}
                                //This field is not required
                                />
                                <span>No</span>
                            </Label>
                            {errors?.ISOTSCertificationsOther && (
                                <div className="text-help">
                                    {errors?.ISOTSCertificationsOther?.message}
                                </div>
                            )}
                            <Row>
                                {
                                    watch("ISOTSCertificationsOther") === "true" && (
                                        <>
                                            <Col md="4">
                                                <div className="d-flex align-items-center">
                                                    <div className="fullinput-icon">
                                                        <TextFieldHookForm
                                                            {...register("OtherCertificationNumber")}
                                                            label={`Certificate Number`}
                                                            Controller={Controller}
                                                            control={control}
                                                            placeholder={"Enter"}
                                                            rules={{
                                                                required: true,
                                                                maxLength: 25,
                                                                validate: { checkWhiteSpaces }
                                                            }}
                                                            customClassName={"withBorder mb-0"}
                                                            handleChange={(e) => {
                                                                // Convert input value to uppercase
                                                                const uppercaseValue = e.target.value.toUpperCase();
                                                                e.target.value = uppercaseValue;
                                                            }}
                                                            errors={errors?.OtherCertificationNumber}
                                                            disabled={false}
                                                            mandatory={true}
                                                        />
                                                    </div>
                                                    <FileUpload
                                                        control={control}
                                                        uploadClass="mt-4 hl-mb-0"
                                                        uploaMainWrap="pt-1"
                                                        {...register("OtherCertificationDocumentAttachment")}
                                                        onFileChange={(file) => handleAttachmentUpload(file, "common", setOtherCertificationDocumentAttachment, "OtherCertificationDocumentAttachment")}
                                                        onDelete={() => {
                                                            setValue("OtherCertificationDocumentAttachment", null);
                                                            setOtherCertificationDocumentAttachment(p => ({ ...p, isRemove: true }))
                                                        }}
                                                        uploadedFile={otherCertificationDocumentAttachment}
                                                        setUploadedFile={setOtherCertificationDocumentAttachment}
                                                        allowedFileTypes={fileConfig.common.allowedFileTypes}
                                                        rules={{ required: "File required" }}
                                                        mandatory={true}
                                                        errors={errors?.OtherCertificationDocumentAttachment}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md='2'>
                                                <TextFieldHookForm
                                                    {...register("OtherCertificationName")}
                                                    label="Certificate Name"
                                                    Controller={Controller}
                                                    control={control}
                                                    placeholder={"Enter"}
                                                    rules={{
                                                        required: true,
                                                        maxLength: 50,
                                                    }}
                                                    customClassName={"withBorder mb-0"}
                                                    handleChange={() => { }}
                                                    errors={errors?.OtherCertificationName}
                                                    disabled={false}
                                                    mandatory={true}
                                                />
                                            </Col>
                                            <Col md="2">
                                                <div className="d-flex align-items-center">
                                                    <div className="fullinput-icon">
                                                        <label>
                                                            Expiry Date
                                                            <span className="asterisk-required">*</span>
                                                        </label>

                                                        <div className="inputbox date-section">
                                                            <Controller
                                                                control={control}
                                                                name="OtherCertificationExpiryDate"
                                                                rules={{ required: "This field is required" }}
                                                                render={({ field }) => (
                                                                    <>
                                                                        <DatePicker
                                                                            placeholderText="Select Date"
                                                                            onChange={(date) => field.onChange(date)}
                                                                            selected={field.value}
                                                                            showMonthDropdown
                                                                            showYearDropdown
                                                                            dropdownMode="select"
                                                                            dateFormat="dd/MM/yyyy"
                                                                            autoComplete="off"
                                                                            disabledKeyboardNavigation
                                                                            onChangeRaw={(e) => e.preventDefault()}
                                                                            className='form-control hl-datepicker-date mh-inherit'
                                                                            minDate={tomorrowDate}
                                                                        />
                                                                        {errors && <span className="text-help">{errors?.OtherCertificationExpiryDate?.message}</span>}
                                                                    </>
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                            </Col>
                                        </>
                                    )
                                }
                            </Row>
                        </Col>
                    </Row>
                    <Row className="part-detail-wrapper d-flex align-items-center">
                        <Col md="12">
                            <HeaderTitle
                                title={"Agreement:"}
                                customClass="mt-3"
                            />
                        </Col>
                    </Row>
                    <Row className="part-detail-wrapper">
                        <Col md="4" className='d-flex align-items-center mb-1'>
                            <Label className='me-3 w-100'>
                                Suppliers Code of Conduct - Havells Group
                                <span className="asterisk-required">*</span>
                            </Label>
                            <div className='mw-120 text-right'>
                                <FileUpload
                                    uploaMainWrap={'pb-2'}
                                    uploadClass="mt-1 ml-0 hl-mb-0"
                                    control={control}
                                    {...register("VendorCodeOfConductAttachment")}
                                    onFileChange={(file) => handleAttachmentUpload(file, "vendorCodeOfConductAttachment", setVendorCodeOfConductAttachment, "VendorCodeOfConductAttachment")}
                                    onDelete={() => {
                                        setValue("VendorCodeOfConductAttachment", null);
                                        setVendorCodeOfConductAttachment(p => ({ ...p, isRemove: true }))
                                    }}
                                    uploadedFile={vendorCodeOfConductAttachment}
                                    setUploadedFile={setVendorCodeOfConductAttachment}
                                    allowedFileTypes={fileConfig.vendorCodeOfConductAttachment.allowedFileTypes}
                                    rules={{ required: "File required" }}
                                    mandatory={true}
                                    errors={errors?.VendorCodeOfConductAttachment}
                                />
                            </div>
                        </Col>
                    </Row>
                    {
                        supplierDetail?.TaxationStatutoryDetails?.IsPSARequired && (
                            <Row className="part-detail-wrapper">
                                <Col md="12"><hr className="hr-seprator mt-2" /></Col>
                                <Col md="4" className='d-flex align-items-center'>
                                    <Label className='me-3 w-100'>
                                        Product Source Agreement/Job work agreement
                                        <span className="asterisk-required">*</span>
                                    </Label>
                                    <div className='mw-120 text-right'>
                                        <FileUpload
                                            uploaMainWrap={'pb-2'}
                                            uploadClass="mt-1 ml-0 hl-mb-0"
                                            control={control}
                                            {...register("ProductSourcingDocumentAttachment")}
                                            onFileChange={(file) => handleAttachmentUpload(file, "productSourcingDocumentAttachment", setProductSourcingDocumentAttachment, "ProductSourcingDocumentAttachment")}
                                            onDelete={() => {
                                                setValue("ProductSourcingDocumentAttachment", null);
                                                setProductSourcingDocumentAttachment(p => ({ ...p, isRemove: true }))
                                            }}
                                            uploadedFile={productSourcingDocumentAttachment}
                                            setUploadedFile={setProductSourcingDocumentAttachment}
                                            allowedFileTypes={fileConfig.productSourcingDocumentAttachment.allowedFileTypes}
                                            rules={{ required: "File required" }}
                                            mandatory={true}
                                            errors={errors?.ProductSourcingDocumentAttachment}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        )
                    }
                    <Row className="part-detail-wrapper mb-2">
                        <Col md="12"><hr className="hr-seprator mt-2" /></Col>
                        <Col md="4" className='d-flex align-items-center'>
                            <Label>
                                Other Agreement (If any)
                            </Label>
                            <div className='mw-120 text-right'>
                                <FileUpload
                                    control={control}
                                    uploaMainWrap={'pb-2'}
                                    uploadClass="mt-1 ml-0 hl-mb-0"
                                    {...register("OtherAgreementDocumentAttachment")}
                                    onFileChange={(file) => handleAttachmentUpload(file, "common", setOtherAgreementDocumentAttachment, "OtherAgreementDocumentAttachment")}
                                    onDelete={() => {
                                        setValue("OtherAgreementDocumentAttachment", null);
                                        setOtherAgreementDocumentAttachment(p => ({ ...p, isRemove: true }))
                                    }}
                                    uploadedFile={otherAgreementDocumentAttachment}
                                    setUploadedFile={setOtherAgreementDocumentAttachment}
                                    allowedFileTypes={fileConfig.common.allowedFileTypes}
                                    errors={errors?.OtherAgreementDocumentAttachment}
                                />
                            </div>
                        </Col>
                    </Row>
                    {
                        (
                            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 &&
                            companyOpcEstablishment.includes(supplierDetail?.KYS1ContactDetails?.RegistrationDetail.CompanyTypeId)
                        ) && (
                            <Row className="part-detail-wrapper">
                                <Col md="12"><hr className="hr-seprator mb-3" /></Col>
                                <Col md='4' className='d-flex mb-3 align-items-center'>
                                    <div className="hl-label d-flex hl-title-tooltip">
                                        <Label className='d-flex align-items-center mb-0'>
                                            Memorandum & Article of association
                                            <span className="asterisk-required">*</span>

                                            <TooltipCustom id="memorandumTooltip"
                                                tooltipText="Upload MOA"
                                                customClass="ml-5"
                                            />
                                        </Label>
                                    </div>
                                    <div className='mw-120 text-right ms-auto'>
                                        <FileUpload
                                            control={control}
                                            uploaMainWrap={'pb-2'}
                                            uploadClass="mt-1 ml-0 hl-mb-0"
                                            {...register("AssociationDocumentAttachment")}
                                            onFileChange={(file) => handleAttachmentUpload(file, "common", setAssociationDocumentAttachment, "AssociationDocumentAttachment")}
                                            onDelete={() => {
                                                setValue("AssociationDocumentAttachment", null);
                                                setAssociationDocumentAttachment(p => ({ ...p, isRemove: true }))
                                            }}
                                            uploadedFile={associationDocumentAttachment}
                                            setUploadedFile={setAssociationDocumentAttachment}
                                            allowedFileTypes={fileConfig.common.allowedFileTypes}
                                            rules={{ required: "File required" }}
                                            mandatory={true}
                                            errors={errors?.AssociationDocumentAttachment}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        )
                    }
                    {
                        (
                            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 &&
                            llpPartnershipEstablishment.includes(supplierDetail?.KYS1ContactDetails?.RegistrationDetail.CompanyTypeId)
                        ) && (
                            <Row className="part-detail-wrapper mb-3">
                                <Col md="12"><hr className="hr-seprator mb-3" /></Col>
                                <Col md='4' className='d-flex align-items-center'>
                                    <Label className='hl-label d-flex hl-title-tooltip'>
                                        Partnership Deed
                                        <span className="asterisk-required">*</span>
                                        <TooltipCustom
                                            id="deedTooltip"
                                            customClass="ml-5"
                                            tooltipText="Upload MOA" /></Label>
                                    <div className='mw-120 text-right ms-auto'>
                                        <FileUpload
                                            control={control}
                                            uploaMainWrap={'pb-2'}
                                            uploadClass="mt-1 ml-0 hl-mb-0"
                                            {...register("PartnershipDeedDocumentAttachment")}
                                            onFileChange={(file) => handleAttachmentUpload(file, "common", setPartnershipDeedDocumentAttachment, "PartnershipDeedDocumentAttachment")}
                                            onDelete={() => {
                                                setValue("PartnershipDeedDocumentAttachment", null);
                                                setPartnershipDeedDocumentAttachment(p => ({ ...p, isRemove: true }))
                                            }}
                                            uploadedFile={partnershipDeedDocumentAttachment}
                                            setUploadedFile={setPartnershipDeedDocumentAttachment}
                                            allowedFileTypes={fileConfig.common.allowedFileTypes}
                                            rules={{ required: "File required" }}
                                            mandatory={true}
                                            errors={errors?.PartnershipDeedDocumentAttachment}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        )
                    }
                    {
                        (
                            supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas == 1 &&
                            societyEstablishment.includes(supplierDetail?.KYS1ContactDetails?.RegistrationDetail.CompanyTypeId)
                        ) && (
                            <Row className="part-detail-wrapper mb-3">
                                <Col md="12"><hr className="hr-seprator mb-3" /></Col>
                                <Col md='4' className='d-flex align-items-center'>
                                    <Label className='w-100 hl-title-tooltip'>Trust Deed
                                        <span className="asterisk-required">*</span>
                                    </Label>
                                    <div className='mw-120 text-right'>
                                        <FileUpload
                                            control={control}
                                            uploaMainWrap={'pb-2'}
                                            uploadClass="mt-1 ml-0 hl-mb-0"
                                            {...register("TrustDeedDocumentAttachment")}
                                            onFileChange={(file) => handleAttachmentUpload(file, "common", setTrustDeedDocumentAttachment, "TrustDeedDocumentAttachment")}
                                            onDelete={() => {
                                                setValue("TrustDeedDocumentAttachment", null);
                                                setTrustDeedDocumentAttachment(p => ({ ...p, isRemove: true }))
                                            }}
                                            uploadedFile={trustDeedDocumentAttachment}
                                            setUploadedFile={setTrustDeedDocumentAttachment}
                                            allowedFileTypes={fileConfig.common.allowedFileTypes}
                                            rules={{ required: "File required" }}
                                            mandatory={true}
                                            errors={errors?.TrustDeedDocumentAttachment}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        )
                    }
                    <Row className="part-detail-wrapper mb-3">
                        <Col md="12"><hr className="hr-seprator mb-3" /></Col>
                        <Col md="4" className='d-flex align-items-center'>
                            <Label>
                                Any Document (if any) Attachments
                            </Label>
                            <div className='mw-120 text-right'>
                                <FileUpload
                                    control={control}
                                    // uploadClass={"mt-1 ml-0"}
                                    {...register("AnyDocumentDocumentAttachment")}
                                    onFileChange={(file) => handleAttachmentUpload(file, "common", setAnyDocumentDocumentAttachment, "AnyDocumentDocumentAttachment")}
                                    onDelete={() => {
                                        setValue("AnyDocumentDocumentAttachment", null);
                                        setAnyDocumentDocumentAttachment(p => ({ ...p, isRemove: true }))
                                    }}
                                    uploadedFile={anyDocumentDocumentAttachment}
                                    setUploadedFile={setAnyDocumentDocumentAttachment}
                                    allowedFileTypes={fileConfig.common.allowedFileTypes}
                                    errors={errors?.AnyDocumentDocumentAttachment}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer mt-5">
                        <div className="col-sm-12 text-right bluefooter-butn d-flex justify-content-end align-items-center">
                            {
                                supplierDetail?.TaxationStatutoryDetails?.IsPSARequired && (
                                    <span className='text-start'>
                                        <FormGroup check inline className='pl-0'>
                                            <Label className="custom-checkbox mb-0" check>
                                                Declaration: - We hereby declare that, we haven't made any changes in Havells product sourcing/job work agreement.<span className="asterisk-required">*</span>
                                                <Controller
                                                    name="Pdagreement"
                                                    control={control}
                                                    rules={{ required: "This field is required." }}
                                                    render={({ field }) => <input checked={field.value} type="checkbox" {...field} />}
                                                />
                                                <span className="before-box"></span>
                                            </Label>
                                            {errors && <span className="text-help" style={{ display: errors.Pdagreement ? 'block' : 'none' }}>{errors?.Pdagreement?.message}</span>}
                                        </FormGroup>
                                    </span>
                                )
                            }
                            <button type={"button"} className="reset mr-2 cancel-btn" onClick={() => props.toggleKys1FormTabs("2")}>
                                <i className="fa fa-long-arrow-left me-2" aria-hidden="true"></i>
                                {"Previous"}
                            </button>
                            <button type="submit" className="submit-button save-btn me-2">
                                <div className="save-icon mr-1"></div>
                                {"Next"}
                            </button>
                        </div>
                    </Row>
                </form >
            </div >
        </>
    )
}

export default TaxationStatutory;
